import {AdminPagingModel} from "./AdminPagingModel";
import {EventService} from "../../services/EventService";
import {NotificationService} from "../../services/NotificationService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Event} from "../../entities/Event";

export class EventAdminPagingModel extends AdminPagingModel<Event>{
    static $inject = ['$q','EventService','NotificationService','GridBookmarkService'];
    constructor($q:ng.IQService, pagingService:EventService,notificationService:NotificationService,
                gridBookmarkService:GridBookmarkService){
        super($q, pagingService,notificationService,gridBookmarkService);
    }
    getCustomActions():string[]{
        return [];
    }
    entityName():string{
        return "event";
    }
    displayName():string{
        return "Events";
    }
    addEditAllowed():boolean{
      return false;
    }
    deleteAllowed():boolean{
      return false;
    }
    getColumnDefs():ng.IPromise<void>{
        this.nameValuePairs =
            [
                ['eventTime', 'Event Time',200],
                ['rfidTag', 'Rfid Tag', 215],
                ['vTagID', 'VTag ID', 215],
                ['readerName', 'Reader Name',120],
                ['readerLocation', 'Reader Location',130],
                ['assetName', 'Asset Name',150],
                ['assetDescription', 'Asset Description',150],
                ['eventType', 'Event Type',110],
                ['thresholdType', 'Threshold Type',135],
                ['eventDetails', 'Event Details',150],
                ['filterAnnotation', 'Filter Annotation',145],
                ['antennaNumber', 'Antenna Number',135],
                ['rssi', 'RSSI',135],
            ];
        return this.$q.when();
    }
}
